if (!customElements.get('before-after')) {
  class BeforeAfter extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.before-after__slider');
      this.separator = this.querySelector('.before-after__separator');
      this.afterImage = this.querySelector('.before-after__image--after');
      this.captions = this.querySelector('.before-after__captions');
      if (!this.slider || !this.separator || !this.afterImage) {
        return;
      }

      this.updateHandler = () => {
        this.updateSeparator();
      };

      this.updateSeparator();
      this.bindEvents();
      this.classList.add('before-after--ready');
    }

    bindEvents() {
      this.slider.addEventListener('input', this.updateHandler);

      this.slider.addEventListener('mouseup', () => {
        this.slider.blur();
      });

      this.slider.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
          this.slider.value = this.slider.min;
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
          this.slider.value = this.slider.max;
        }
        this.applyInteractiveTransition();
      });

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this.updateHandler);
        this.resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.updateHandler);
        this.hasWindowResizeListener = true;
      }
    }

    applyInteractiveTransition() {
      const easing = '400ms ease-out';
      this.separator.style.transition = `left ${easing}`;
      this.afterImage.style.transition = `width ${easing}`;
      this.updateSeparator();

      const cleanup = () => {
        this.separator.style.transition = '';
        this.afterImage.style.transition = '';
        this.separator.removeEventListener('transitionend', cleanup);
        this.afterImage.removeEventListener('transitionend', cleanup);
      };

      this.separator.addEventListener('transitionend', cleanup, { once: true });
      this.afterImage.addEventListener('transitionend', cleanup, { once: true });
    }

    updateSeparator() {
      const value = Number(this.slider.value);
      const min = Number(this.slider.min);
      const max = Number(this.slider.max);
      const range = max - min || 1;
      const position = ((value - min) / range) * 100;
      this.separator.style.left = `${position}%`;
      this.afterImage.style.width = `${100 - position}%`;
    }

    disconnectedCallback() {
      this.slider.removeEventListener('input', this.updateHandler);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.hasWindowResizeListener) {
        window.removeEventListener('resize', this.updateHandler);
      }
    }
  }

  customElements.define('before-after', BeforeAfter);
}

